import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import Auth from "auth"
import AuthRoutes from "routes/auth.jsx"
import Wording from "configs/Wording.jsx"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import PagesHeader from "components/Header/PagesHeader.jsx";
import Footer from "components/Footer/Footer.jsx";

import pagesRoutes from "routes/pages.jsx";

import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";

// import bgImage from "assets/img/bg_mizuno.jpg";
import bgImage from "assets/img/register.jpeg";
// import bgImage from "assets/img/header-doc.jpeg";

class Pages extends React.Component {
  componentDidMount() {
    document.body.style.overflow = "unset";
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <PagesHeader {...rest} appName={Wording.AppName} />
        <div className={classes.wrapper} ref="wrapper">
          <div
            className={classes.fullPage}
            style={{ backgroundImage: "url(" + bgImage + ")" }}
          >
            <Switch>
              {pagesRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return null;
                }
                if (prop.redirect) {
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                }
                if (prop.forGuest && Auth.isAuthentication()) {
                  const user_type_code = Auth.getUserData().user_type_code
                  if (AuthRoutes[user_type_code] != undefined) {
                    return (
                      <Redirect from={prop.path} to={AuthRoutes[user_type_code].forNoGuest} key={key} />
                    );
                  } else {
                    return (
                      <Redirect from={prop.path} to={AuthRoutes.default.forNoGuest} key={key} />
                    );
                  }
                }
                if (prop.forLogin && !Auth.isAuthentication()) {
                  return (
                    <Redirect from={prop.path} to={AuthRoutes.default.forNoLogin} key={key} />
                  );
                }
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer white />
          </div>
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(pagesStyle)(Pages);
